import { IExclusivityAvailabilityState } from "@faire/web-api/faire/exclusivity_agreement/client/IExclusivityAvailabilityState";
import { IGetRetailerExclusivityAvailabilityWithBrandResponse } from "@faire/web-api/faire/exclusivity_agreement/client/IGetRetailerExclusivityAvailabilityWithBrandResponse";

import State = IExclusivityAvailabilityState.State;

export interface StateInfo {
  isActivated: boolean;
  isAvailable: boolean;
  isBlocked: boolean;
  isNotActivatedOrAvailable: boolean;
  isNotEnabled: boolean;
  isUnknown: boolean;
  isZipCodeBlocked: boolean;
}

export const getStateInfoFromAvailability = (
  status: IGetRetailerExclusivityAvailabilityWithBrandResponse | undefined
): StateInfo => {
  if (!status?.state) {
    return {
      isActivated: false,
      isAvailable: false,
      isBlocked: false,
      isNotEnabled: false,
      isNotActivatedOrAvailable: false,
      isZipCodeBlocked: false,
      isUnknown: true,
    };
  }

  const isActivated = ACTIVATED_STATES.includes(status.state);
  const isAvailable = AVAILABLE_STATES.includes(status.state);
  const isBlocked = BLOCKED_STATES.includes(status.state);
  const isUnknown = status.state === State.STATE_UNKNOWN;
  const isNotEnabled = NOT_ENABLED_STATES.includes(status.state);
  const isZipCodeBlocked = status.state === State.ZIPCODE_BLOCKED;
  return {
    isActivated,
    isAvailable,
    isBlocked,
    isUnknown,
    isNotEnabled,
    isZipCodeBlocked,
    isNotActivatedOrAvailable: !(isActivated || isAvailable),
  };
};

const ACTIVATED_STATES: Array<keyof typeof State | undefined> = [
  State.ACTIVE,
  State.PENDING,
];
const AVAILABLE_STATES: Array<keyof typeof State | undefined> = [
  State.AVAILABLE,
];
const NOT_ENABLED_STATES: Array<keyof typeof State | undefined> = [
  State.NOT_ENABLED,
];
const BLOCKED_STATES: Array<keyof typeof State | undefined> = [State.BLOCKED];
